// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FeedbackCollapseController from "./feedback_collapse_controller"
application.register("feedback-collapse", FeedbackCollapseController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import WritingPreferencesController from "./writing_preferences_controller"
application.register("writing-preferences", WritingPreferencesController)
